import React from 'react';
import ProjectsList from './components/project-list.tsx';
import ExperienceSection from './components/Experience.tsx';
import FrameworkSection from './components/Framework.tsx';
import Contact from './components/Contact.tsx';
import ProfileCard from "./components/profile-card.tsx";

const portfolioData = {
  profile: {
    name: "Naterfute",
    title: "Full Stack Developer",
    bio: "I'm Naterfute, A fullstack dev based in the USA.",
    avatar: "/kitty.png",
    socials: [
      { name: "github", url: "https://github.com/naterfute", color: "#6e7681" },
      { name: "gitlab", url: "https://gitlab.com/naterfute", color: "#FC6D26" },
      { name: "codeberg", url: "https://codeberg.org/naterfute", color: "#2185D0" },
      // { name: "linkedin", url: "https://www.linkedin.com/in/kaleb-schmidlkofer-3249a7344/" },
      // { name: "twitter", url: "https://twitter.com/naterfute" },
    ],
    currentProject: {
      text: "Currently the public maintainer for the",
      name: "Hydrodactyl",
      url: "https://github.com/blueprintframework/hydrodactyl",
    },
  },
  experience: {
    languages: [
      {
        name: "Python",
        icon: "python",
        proficiency: "Advanced",
        description: "My most frequently used and favorite language.",
      },
      {
        name: "GdScript",
        icon: "gdscript",
        proficiency: "Intermediate",
        description: "A language used for making games, I use it in the Open Source Godot Fork Blazium",
      },
      {
        name: "TypeScript",
        icon: "typescript",
        proficiency: "Intermediate",
        description: "This is my preferred language for frontend dev. I shan't use it for backend, other languages excel at this far better than this one.",
      },
      {
        name: "Zig",
        icon: "zig",
        proficiency: "Beginner",
        description: "Zig is quickly becoming one of my favorite languages, it's especially handy when doing low level, or high performance tasks.",
      },
    ],
    frameworks: [
      {
        name: "Django",
        description: "A fullstack Framework for python that I use for apps such as my blog"
      },
      {
        name: "Fastapi",
        description: "a modern web framework for building APIs with Python."
      },
      {
        name: "Flask",
        description: "Similar to Django, I use this framework for making lightweight apps that require robust solutions."
      },
      {
        name: "Kubernetes",
        description: "An Open Source System for container orchestration"
      },
      {
        name: "ArgoCD",
        description: "A declarative, GitOps continuous delivery tool for Kubernetes."
      },
      {
        name: "Proxmox",
        description: "Open source KVM Management Interface"
      },
    ]
  },
  projects: [
    {
      name: "Hydrodactyl",
      description:
        "Pyrodactyl is the Pterodactyl-based game server panel that's faster, smaller, safer, and more accessible than Pelican. ",
      link: "https://hydrodactyl.dev",
      repo: "https://github.com/blueprintframework/hydrodactyl",
      languages: ["TypeScript", "Php", "React", "Vite", "PostgreSQL", "Mysql", "MariaDB"],
    },
    {
      name: "Yttrium",
      description:
        "A web-server written in Python to download music from youtube using yt-dlp ",
      link: "https://github.com/naterfute/yttrium",
      repo: "https://github.com/naterfute/yttrium",
      languages: ["Python", "PostgreSQL", "Mysql", "Mariadb", "sqlite"],
    },
    {
      name: "Blazium Community Bot",
      description:
        "A Discord bot written in python for the Blazium Engine Server.",
      link: "https://github.com/nateQK/NateQK",
      repo: "https://github.com/nateQK/NateQK",
      languages: ["Python", "Hikari-py", "Hikari-arc"],
    },
  ],
}


const App: React.FC = () => {
  return (
    <div className="container mx-auto w-full">
      <ProfileCard
        name={portfolioData.profile.name}
        title={portfolioData.profile.title}
        bio={portfolioData.profile.bio}
        avatar={portfolioData.profile.avatar}
        socials={portfolioData.profile.socials}
        currentProject={portfolioData.profile.currentProject}
      />
      <h2 className="flex justify-center items-center w-full my-10 font-extrabold text-5xl text-text">Projects</h2>

      <ProjectsList projects={portfolioData.projects} />

      <h2 className="flex justify-center items-center w-full font-extrabold text-5xl text-text">Experience</h2>
      <div className="container md:flex md:row column ">
        <ExperienceSection languages={portfolioData.experience.languages} />
        <FrameworkSection languages={portfolioData.experience.frameworks} />
      </div>

      <Contact />
    </div>
  );
};

export default App;

